import React from "react";
import { Grid } from "@mui/material";
import ChipInputField from "../../../utils/FormFields/ChipInputField";
import { InputField, SelectField } from "../../../utils/FormFields";
import { Tests } from "../../../api/medical-operations";

const Observation = ({ index, tests }: any) => {
  const availableTests = tests?.map((test: Tests) => {
    return {
      label: test.Name,
      value: test.Code,
    };
  });

  return (

      <Grid container rowSpacing={6} spacing={2} sx={{ pt: 2, justifyContent: "center", alignContent: "center" }}>
        <Grid item xs={12} sm={10} sx={{ mb: -3 }}>
          <InputField
            name={`Observations[${index}].ObservationNb`}
            label="Observation Number"
            fullWidth
            disabled
            variant="filled"
          />
        </Grid>
        <Grid container />
        
        <Grid item xs={12} sm={10}>
          <ChipInputField name={`Observations[${index}].Symptoms`} label="Symptoms (Enter When Done)" />
        </Grid>
        <Grid container />
        <Grid item xs={12} sm={10}>
          {/* <AutocompleteTestChip name={`Observations[${index}].RequestedTests`} label="Requested Tests" tests={tests} /> */}
          <SelectField
            name={`Observations[${index}].RequestedTests`}
            label="Requested Tests"
            data={availableTests}
            multiple={true}
          />
        </Grid>
        <Grid container />
        <Grid item xs={12} sm={10} sx={{ mt: -3,mb:3 }}>
          <ChipInputField
            name={`Observations[${index}].Feedback`}
            label="Feedback (Enter When Done)"
            multiline
            rows={4}
            fullWidth
            variant="filled"
          />
        </Grid>
      </Grid>
  );
};

export default Observation;
